import {Message} from '@/plugins/element-ui/element-ui'

export function showSuccessMessage(msg) {
    Message.success(msg)
}

export function showInfoMessage(msg) {
    Message.info(msg)
}

export function showWarnMessage(msg) {
    Message.warning(msg)
}

export function showErrorMessage(msg) {
    Message.error(msg)
}
